/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { toast } from 'react-toastify';
import { isNil } from 'lodash';

import moment from 'moment';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  DialogActions,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Switch,
  FormControlLabel,
  Grid,
  Tab,
  Tabs,
  Paper,
  Box,
  useTheme,
} from '@mui/material';

import { Autorenew, FileCopy, DeleteOutline } from '@mui/icons-material';

import api from '../../services/api';
import { i18n } from '../../translate/i18n';
import toastError from '../../toasts/toastError';

import QueueSelect from '../QueueSelect';
import TabPanel from '../TabPanel';
import { getStyled } from './styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const SessionSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
});

const WhatsAppModal = ({ open, onClose, whatsAppId }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [autoToken, setAutoToken] = useState('');

  const inputFileRef = useRef(null);

  const [attachment, setAttachment] = useState(null);
  const [attachmentName, setAttachmentName] = useState('');

  const initialState = {
    name: '',
    greetingMessage: '',
    complationMessage: '',
    outOfHoursMessage: '',
    ratingMessage: '',
    isDefault: false,
    token: '',
    maxUseBotQueues: 3,
    provider: 'beta',
    expiresTicket: 0,
    allowGroup: false,
    enableImportMessage: false,
    groupAsTicket: 'disabled',
    timeUseBotQueues: '0',
    timeSendQueue: '0',
    sendIdQueue: 0,
    expiresTicketNPS: '0',
    expiresInactiveMessage: '',
    timeInactiveMessage: '',
    inactiveMessage: '',
    maxUseBotQueuesNPS: 3,
    whenExpiresTicket: 0,
    timeCreateNewTicket: 0,
    greetingMediaAttachment: '',
    importRecentMessages: '',
    importOldMessages: '',
    importOldMessagesGroups: '',
    integrationId: '',
    collectiveVacationEnd: '',
    collectiveVacationStart: '',
    collectiveVacationMessage: '',
    queueIdImportMessages: null,
  };

  const [whatsApp, setWhatsApp] = useState(initialState);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);
  const [queues, setQueues] = useState([]);
  const [tab, setTab] = useState('general');
  const [enableImportMessage, setEnableImportMessage] = useState(false);
  const [importOldMessagesGroups, setImportOldMessagesGroups] = useState(false);
  const [closedTicketsPostImported, setClosedTicketsPostImported] =
    useState(false);
  const [importOldMessages, setImportOldMessages] = useState(
    moment().add(-1, 'days').format('YYYY-MM-DDTHH:mm'),
  );
  const [importRecentMessages, setImportRecentMessages] = useState(
    moment().add(-1, 'minutes').format('YYYY-MM-DDTHH:mm'),
  );
  const [copied, setCopied] = useState(false);

  const [selectedPrompt, setSelectedPrompt] = useState(null);

  function generateRandomCode(length) {
    const charset =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyvz0123456789';
    let code = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      code += charset.charAt(randomIndex);
    }
    return code;
  }

  useEffect(() => {
    try {
      if (!whatsAppId && !whatsApp.token) {
        setAutoToken(generateRandomCode(30));
      } else if (whatsAppId && !whatsApp.token) {
        setAutoToken(generateRandomCode(30));
      } else {
        setAutoToken(whatsApp.token);
      }
    } catch (e) {
      throw e.message;
    }
  }, [whatsAppId, whatsApp]);

  const handleEnableImportMessage = async (e) => {
    setEnableImportMessage(e.target.checked);
  };

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`whatsapp/${whatsAppId}?session=0`);
        setWhatsApp(data);
        setAttachmentName(data.greetingMediaAttachment);
        setAutoToken(data.token);
        data.promptId
          ? setSelectedPrompt(data.promptId)
          : setSelectedPrompt(null);
        const whatsQueueIds = data.queues?.map((queue) => queue.id);
        setSelectedQueueIds(whatsQueueIds);
        if (!isNil(data?.importOldMessages)) {
          setEnableImportMessage(true);
          setImportOldMessages(data?.importOldMessages);
          setImportRecentMessages(data?.importRecentMessages);
          setClosedTicketsPostImported(data?.closedTicketsPostImported);
          setImportOldMessagesGroups(data?.importOldMessagesGroups);
        }
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/queue');
        setQueues(data);
      } catch (err) {
        toastError(err);
      }
    })();
  }, []);

  const handleChangeQueue = (e) => {
    setSelectedQueueIds(e);
  };

  const handleSaveWhatsApp = async (values) => {
    if (!whatsAppId) setAutoToken(generateRandomCode(30));

    if (values.timeSendQueue === '') values.timeSendQueue = '0';

    if (
      (values.sendIdQueue === 0 ||
        values.sendIdQueue === '' ||
        isNil(values.sendIdQueue)) &&
      values.timeSendQueue !== 0 &&
      values.timeSendQueue !== '0'
    ) {
      toastError(i18n.t('whatsappModal.errorSendQueue'));
      return;
    }

    const whatsappData = {
      ...values,
      flowIdWelcome: null,
      flowIdNotPhrase: null,
      integrationId: selectedQueueIds,
      queueIds: selectedQueueIds,
      importOldMessages: enableImportMessage ? importOldMessages : null,
      importRecentMessages: enableImportMessage ? importRecentMessages : null,
      importOldMessagesGroups: importOldMessagesGroups
        ? importOldMessagesGroups
        : null,
      closedTicketsPostImported: closedTicketsPostImported
        ? closedTicketsPostImported
        : null,
      token: autoToken ? autoToken : null,
      promptId: selectedPrompt ? selectedPrompt : null,
    };

    console.dir(whatsappData);

    delete whatsappData['queues'];
    delete whatsappData['session'];

    try {
      if (whatsAppId) {
        if (
          whatsAppId &&
          enableImportMessage &&
          whatsApp?.status === 'CONNECTED'
        ) {
          try {
            setWhatsApp({ ...whatsApp, status: 'qrcode' });
            await api.delete(`/whatsappsession/${whatsApp.id}`);
          } catch (err) {
            toastError(err);
          }
        }

        await api.put(`/whatsapp/${whatsAppId}`, whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append('file', attachment);
          await api.post(`/whatsapp/${whatsAppId}/media-upload`, formData);
        }
        if (!attachmentName && whatsApp.greetingMediaAttachment !== null) {
          await api.delete(`/whatsapp/${whatsAppId}/media-upload`);
        }
      } else {
        const { data } = await api.post('/whatsapp', whatsappData);
        if (attachment != null) {
          const formData = new FormData();
          formData.append('file', attachment);
          await api.post(`/whatsapp/${data.id}/media-upload`, formData);
        }
      }
      toastSuccess(i18n.t('whatsappModal.success'));

      handleClose();
    } catch (err) {
      toastError(err);
    }
  };

  const handleRefreshToken = () => {
    setAutoToken(generateRandomCode(30));
    setCopied(false);
  };

  const handleCopyToken = () => {
    navigator.clipboard.writeText(autoToken);
    setCopied(true);
  };

  const handleClose = () => {
    onClose();
    setWhatsApp(initialState);
    setEnableImportMessage(false);
    setAttachment(null);
    setAttachmentName('');
    setCopied(false);
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleFileUpload = () => {
    const file = inputFileRef.current.files[0];
    setAttachment(file);
    setAttachmentName(file.name);
    inputFileRef.current.value = null;
  };

  const handleDeleFile = () => {
    setAttachment(null);
    setAttachmentName(null);
  };

  return (
    <div style={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
        fullWidth
        scroll='paper'
      >
        <DialogTitle sx={theme.custom.dialogColor}>
          {whatsAppId
            ? i18n.t('whatsappModal.title.edit')
            : i18n.t('whatsappModal.title.add')}
        </DialogTitle>
        <Formik
          initialValues={whatsApp}
          enableReinitialize={true}
          validationSchema={SessionSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveWhatsApp(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, touched, errors, isSubmitting }) => (
            <Form>
              <Paper sx={classes.mainPaper} elevation={1}>
                <Tabs
                  value={tab}
                  indicatorColor='primary'
                  textColor='primary'
                  scrollButtons='on'
                  variant='scrollable'
                  onChange={handleTabChange}
                  sx={classes.tab}
                >
                  <Tab
                    label={i18n.t('whatsappModal.tabs.general')}
                    value={'general'}
                  />
                  <Tab
                    label={i18n.t('whatsappModal.tabs.messages')}
                    value={'messages'}
                  />
                </Tabs>
              </Paper>
              <Paper sx={classes.paper} elevation={0}>
                <TabPanel sx={classes.container} value={tab} name={'general'}>
                  <DialogContent dividers sx={theme.custom.dialogColor}>
                    {attachmentName && (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row-reverse',
                        }}
                      >
                        <Button
                          variant='outlined'
                          color='primary'
                          endIcon={<DeleteOutline />}
                          onClick={handleDeleFile}
                        >
                          {attachmentName}
                        </Button>
                      </div>
                    )}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column-reverse',
                      }}
                    >
                      <input
                        type='file'
                        accept='video/*,image/*'
                        ref={inputFileRef}
                        style={{ display: 'none' }}
                        onChange={handleFileUpload}
                      />
                      <Button
                        variant='outlined'
                        sx={theme.custom.editButton}
                        onClick={() => inputFileRef.current.click()}
                      >
                        {i18n.t('userModal.buttons.addImage')}
                      </Button>
                    </div>
                    {/* NOME E PADRAO */}
                    <div style={classes.multFieldLine}>
                      <Grid spacing={2} container>
                        <Field
                          as={TextField}
                          label={i18n.t('whatsappModal.form.name')}
                          autoFocus
                          name='name'
                          error={touched.name && Boolean(errors.name)}
                          helperText={touched.name && errors.name}
                          variant='outlined'
                          margin='dense'
                          sx={theme.custom.textField}
                          fullWidth
                        />
                        <Grid style={{ paddingTop: 15 }}>
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                                color='primary'
                                name='isDefault'
                                checked={values.isDefault}
                                sx={theme.custom.switch}
                              />
                            }
                            label={i18n.t('whatsappModal.form.default')}
                          />
                          <FormControlLabel
                            control={
                              <Field
                                as={Switch}
                                name='allowGroup'
                                checked={values.allowGroup}
                                sx={theme.custom.switch}
                              />
                            }
                            label={i18n.t('whatsappModal.form.group')}
                          />
                        </Grid>
                        <Grid size={{ xs: 6, md: 4 }}>
                          <FormControl
                            variant='outlined'
                            margin='dense'
                            fullWidth
                            sx={classes.formControl}
                          >
                            <InputLabel
                              id='groupAsTicket-selection-label'
                              sx={theme.custom.label}
                            >
                              {i18n.t('whatsappModal.form.groupAsTicket')}
                            </InputLabel>
                            <Field
                              as={Select}
                              label={i18n.t('whatsappModal.form.groupAsTicket')}
                              placeholder={i18n.t(
                                'whatsappModal.form.groupAsTicket',
                              )}
                              labelId='groupAsTicket-selection-label'
                              id='groupAsTicket'
                              name='groupAsTicket'
                              sx={{ ...theme.custom.textField, marginRight: 0 }}
                              MenuProps={theme.custom.menuProps}
                            >
                              <MenuItem value={'disabled'}>
                                {i18n.t('whatsappModal.menuItem.disabled')}
                              </MenuItem>
                              <MenuItem value={'enabled'}>
                                {i18n.t('whatsappModal.menuItem.enabled')}
                              </MenuItem>
                            </Field>
                          </FormControl>
                        </Grid>
                      </Grid>

                      {/* FILAS */}

                      <QueueSelect
                        selectedQueueIds={selectedQueueIds}
                        onChange={(selectedIds) =>
                          handleChangeQueue(selectedIds)
                        }
                      />
                    </div>

                    <div style={classes.importMessage}>
                      <div
                        style={{
                          ...classes.multFieldInline,
                          justifyContent: enableImportMessage
                            ? 'space-around'
                            : 'flex-start',
                          transform: enableImportMessage && 'translateX(2%)',
                        }}
                      >
                        <FormControlLabel
                          sx={{ marginRight: 7, color: 'gray' }}
                          label={i18n.t(
                            'whatsappModal.form.importOldMessagesEnable',
                          )}
                          labelPlacement='end'
                          control={
                            <Switch
                              size='medium'
                              checked={enableImportMessage}
                              onChange={handleEnableImportMessage}
                              name='importOldMessagesEnable'
                              sx={theme.custom.switch}
                            />
                          }
                        />

                        {enableImportMessage && (
                          <FormControlLabel
                            sx={{ marginRight: 7, color: 'gray' }}
                            label={i18n.t(
                              'whatsappModal.form.importOldMessagesGroups',
                            )}
                            labelPlacement='end'
                            control={
                              <Switch
                                size='medium'
                                checked={importOldMessagesGroups}
                                onChange={(e) =>
                                  setImportOldMessagesGroups(e.target.checked)
                                }
                                name='importOldMessagesGroups'
                                sx={theme.custom.switch}
                              />
                            }
                          />
                        )}

                        {enableImportMessage && (
                          <FormControlLabel
                            sx={{ marginRight: 7, color: 'gray' }}
                            label={i18n.t(
                              'whatsappModal.form.closedTicketsPostImported',
                            )}
                            labelPlacement='end'
                            control={
                              <Switch
                                size='medium'
                                checked={closedTicketsPostImported}
                                onChange={(e) =>
                                  setClosedTicketsPostImported(e.target.checked)
                                }
                                name='closedTicketsPostImported'
                                sx={theme.custom.switch}
                              />
                            }
                          />
                        )}
                      </div>

                      {enableImportMessage && (
                        <Grid sx={{ marginTop: 2 }} container spacing={1}>
                          <Grid size={{ xs: 6 }}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t(
                                'whatsappModal.form.importOldMessages',
                              )}
                              type='datetime-local'
                              name='importOldMessages'
                              inputProps={{
                                max: moment()
                                  .add(0, 'minutes')
                                  .format('YYYY-MM-DDTHH:mm'),
                                min: moment()
                                  .add(-2, 'years')
                                  .format('YYYY-MM-DDTHH:mm'),
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.importOldMessages &&
                                Boolean(errors.importOldMessages)
                              }
                              helperText={
                                touched.importOldMessages &&
                                errors.importOldMessages
                              }
                              variant='outlined'
                              value={moment(importOldMessages).format(
                                'YYYY-MM-DDTHH:mm',
                              )}
                              onChange={(e) => {
                                setImportOldMessages(e.target.value);
                              }}
                              sx={theme.custom.textField}
                            />
                          </Grid>
                          <Grid size={{ xs: 6 }}>
                            <Field
                              fullWidth
                              as={TextField}
                              label={i18n.t(
                                'whatsappModal.form.importRecentMessages',
                              )}
                              type='datetime-local'
                              name='importRecentMessages'
                              inputProps={{
                                max: moment()
                                  .add(0, 'minutes')
                                  .format('YYYY-MM-DDTHH:mm'),
                                min: moment(importOldMessages).format(
                                  'YYYY-MM-DDTHH:mm',
                                ),
                              }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              error={
                                touched.importRecentMessages &&
                                Boolean(errors.importRecentMessages)
                              }
                              helperText={
                                touched.importRecentMessages &&
                                errors.importRecentMessages
                              }
                              variant='outlined'
                              value={moment(importRecentMessages).format(
                                'YYYY-MM-DDTHH:mm',
                              )}
                              onChange={(e) => {
                                setImportRecentMessages(e.target.value);
                              }}
                              sx={theme.custom.textField}
                            />
                          </Grid>
                          <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                            <FormControl
                              variant='outlined'
                              margin='dense'
                              sx={classes.FormControl}
                              fullWidth
                            >
                              <InputLabel
                                id='queueIdImportMessages-selection-label'
                                sx={theme.custom.label}
                              >
                                {i18n.t(
                                  'whatsappModal.form.queueIdImportMessages',
                                )}
                              </InputLabel>
                              <Field
                                as={Select}
                                name='queueIdImportMessages'
                                id='queueIdImportMessages'
                                value={values.queueIdImportMessages || '0'}
                                required={enableImportMessage}
                                label={i18n.t(
                                  'whatsappModal.form.queueIdImportMessages',
                                )}
                                placeholder={i18n.t(
                                  'whatsappModal.form.queueIdImportMessages',
                                )}
                                labelId='queueIdImportMessages-selection-label'
                                sx={{
                                  ...theme.custom.textField,
                                  marginRight: 0,
                                }}
                                MenuProps={theme.custom.menuProps}
                              >
                                <MenuItem value={0}>&nbsp;</MenuItem>
                                {queues.map((queue) => (
                                  <MenuItem key={queue.id} value={queue.id}>
                                    {queue.name}
                                  </MenuItem>
                                ))}
                              </Field>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}
                    </div>
                    {enableImportMessage && (
                      <span style={{ color: 'red' }}>
                        {i18n.t('whatsappModal.form.importAlert')}
                      </span>
                    )}

                    {/* TOKEN */}
                    <Box
                      display='flex'
                      alignItems='center'
                      sx={{ marginTop: 1, width: '100%' }}
                    >
                      <Field
                        as={TextField}
                        label={i18n.t('whatsappModal.form.token')}
                        type='token'
                        fullWidth
                        value={autoToken}
                        variant='outlined'
                        margin='dense'
                        disabled
                        sx={theme.custom.textField}
                      />
                      <Button
                        onClick={handleRefreshToken}
                        disabled={isSubmitting}
                        sx={classes.tokenRefresh}
                        variant='text'
                        startIcon={
                          <Autorenew
                            sx={{
                              marginLeft: 2,
                              color: theme.custom.colors.confirmButton,
                            }}
                          />
                        }
                      />
                      <Button
                        onClick={handleCopyToken}
                        sx={classes.tokenRefresh}
                        variant='text'
                        startIcon={
                          <FileCopy
                            sx={{
                              color: copied
                                ? theme.custom.colors.editButton
                                : theme.palette.mode === 'light'
                                  ? '#1da1f2'
                                  : '#FFF',
                            }}
                          />
                        }
                      />
                    </Box>

                    <div>
                      <h3>{i18n.t('whatsappModal.form.queueRedirection')}</h3>
                      <p>{i18n.t('whatsappModal.form.queueRedirectionDesc')}</p>
                      <Grid spacing={2} container>
                        <Grid size={{ xs: 6, md: 6 }}>
                          <FormControl
                            variant='outlined'
                            margin='dense'
                            sx={classes.FormControl}
                            fullWidth
                          >
                            <InputLabel
                              id='sendIdQueue-selection-label'
                              sx={theme.custom.label}
                            >
                              {i18n.t('whatsappModal.form.sendIdQueue')}
                            </InputLabel>
                            <Field
                              as={Select}
                              name='sendIdQueue'
                              id='sendIdQueue'
                              value={values.sendIdQueue || '0'}
                              required={values.timeSendQueue > 0}
                              label={i18n.t('whatsappModal.form.sendIdQueue')}
                              placeholder={i18n.t(
                                'whatsappModal.form.sendIdQueue',
                              )}
                              labelId='sendIdQueue-selection-label'
                              sx={theme.custom.textField}
                              MenuProps={theme.custom.menuProps}
                            >
                              <MenuItem value={0}>&nbsp;</MenuItem>
                              {queues.map((queue) => (
                                <MenuItem key={queue.id} value={queue.id}>
                                  {queue.name}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </Grid>

                        <Grid size={{ xs: 6, md: 6 }}>
                          <Field
                            as={TextField}
                            label={i18n.t('whatsappModal.form.timeSendQueue')}
                            fullWidth
                            name='timeSendQueue'
                            variant='outlined'
                            margin='dense'
                            error={
                              touched.timeSendQueue &&
                              Boolean(errors.timeSendQueue)
                            }
                            helperText={
                              touched.timeSendQueue && errors.timeSendQueue
                            }
                            sx={theme.custom.textField}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </DialogContent>
                </TabPanel>
                <TabPanel sx={classes.container} value={tab} name={'messages'}>
                  <DialogContent dividers sx={theme.custom.dialogColor}>
                    {/* MENSAGEM DE SAUDAÇÃO */}
                    <Grid container spacing={1}>
                      <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                        <Field
                          as={TextField}
                          label={i18n.t('whatsappModal.form.greetingMessage')}
                          type='greetingMessage'
                          multiline
                          rows={4}
                          fullWidth
                          name='greetingMessage'
                          error={
                            touched.greetingMessage &&
                            Boolean(errors.greetingMessage)
                          }
                          helperText={
                            touched.greetingMessage && errors.greetingMessage
                          }
                          variant='outlined'
                          margin='dense'
                          sx={theme.custom.textField}
                        />
                      </Grid>

                      {/* MENSAGEM DE FORA DE EXPEDIENTE */}
                      <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                        <Field
                          as={TextField}
                          label={i18n.t('whatsappModal.form.outOfHoursMessage')}
                          multiline
                          rows={4}
                          fullWidth
                          name='outOfHoursMessage'
                          error={
                            touched.outOfHoursMessage &&
                            Boolean(errors.outOfHoursMessage)
                          }
                          helperText={
                            touched.outOfHoursMessage &&
                            errors.outOfHoursMessage
                          }
                          variant='outlined'
                          margin='dense'
                          sx={theme.custom.textField}
                        />
                      </Grid>
                      {/* MENSAGEM DE FÉRIAS COLETIVAS */}
                      <Grid size={{ xs: 12, md: 12, xl: 12 }}>
                        <Field
                          as={TextField}
                          label={i18n.t(
                            'whatsappModal.form.collectiveVacationMessage',
                          )}
                          multiline
                          rows={4}
                          fullWidth
                          name='collectiveVacationMessage'
                          error={
                            touched.collectiveVacationMessage &&
                            Boolean(errors.collectiveVacationMessage)
                          }
                          helperText={
                            touched.collectiveVacationMessage &&
                            errors.collectiveVacationMessage
                          }
                          variant='outlined'
                          margin='dense'
                          sx={theme.custom.textField}
                        />
                      </Grid>
                      <Grid size={{ xs: 6 }}>
                        <LocalizationProvider
                          dateAdapter={AdapterMoment}
                          adapterLocale='pt-br'
                        >
                          <DatePicker
                            value={
                              values.collectiveVacationStart
                                ? moment(values.collectiveVacationStart)
                                : null
                            }
                            onChange={(newValue) => {
                              setFieldValue(
                                'collectiveVacationStart',
                                newValue
                                  ? moment(newValue).format('YYYY-MM-DD')
                                  : '',
                              );
                            }}
                            label={i18n.t(
                              'whatsappModal.form.collectiveVacationStart',
                            )}
                            format='DD/MM/YYYY'
                            enableAccessibleFieldDOMStructure={false}
                            slots={{ textField: TextField }}
                            slotProps={{
                              textField: {
                                variant: 'outlined',
                                margin: 'dense',
                                fullWidth: true,
                                name: 'collectiveVacationStart',
                                required:
                                  values.collectiveVacationMessage?.length > 0,
                                error:
                                  touched.collectiveVacationStart &&
                                  Boolean(errors.collectiveVacationStart),
                                helperText:
                                  touched.collectiveVacationStart &&
                                  errors.collectiveVacationStart,
                                sx: classes.datePickerField,
                                InputLabelProps: { shrink: true },
                                inputProps: {
                                  min: moment()
                                    .add(-10, 'days')
                                    .format('YYYY-MM-DD'),
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                      <Grid size={{ xs: 6 }}>
                        <LocalizationProvider
                          dateAdapter={AdapterMoment}
                          adapterLocale='pt-br'
                        >
                          <DatePicker
                            value={
                              values.collectiveVacationEnd
                                ? moment(values.collectiveVacationEnd)
                                : null
                            }
                            onChange={(newValue) => {
                              setFieldValue(
                                'collectiveVacationEnd',
                                newValue
                                  ? moment(newValue).format('YYYY-MM-DD')
                                  : '',
                              );
                            }}
                            label={i18n.t(
                              'whatsappModal.form.collectiveVacationEnd',
                            )}
                            format='DD/MM/YYYY'
                            enableAccessibleFieldDOMStructure={false}
                            slots={{ textField: TextField }}
                            slotProps={{
                              textField: {
                                variant: 'outlined',
                                margin: 'dense',
                                fullWidth: true,
                                name: 'collectiveVacationEnd',
                                required:
                                  values.collectiveVacationMessage?.length > 0,
                                error:
                                  touched.collectiveVacationEnd &&
                                  Boolean(errors.collectiveVacationEnd),
                                helperText:
                                  touched.collectiveVacationEnd &&
                                  errors.collectiveVacationEnd,
                                sx: classes.datePickerField,
                                InputLabelProps: { shrink: true },
                                inputProps: {
                                  min: moment()
                                    .add(-10, 'days')
                                    .format('YYYY-MM-DD'),
                                },
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Grid>
                    </Grid>
                  </DialogContent>
                </TabPanel>
              </Paper>
              <DialogActions sx={theme.custom.dialogColor}>
                <Button
                  onClick={handleClose}
                  sx={theme.custom.cancelButton}
                  disabled={isSubmitting}
                  variant='outlined'
                >
                  {i18n.t('whatsappModal.buttons.cancel')}
                </Button>
                <Button
                  type='submit'
                  disabled={isSubmitting}
                  variant='outlined'
                  sx={theme.custom.confirmButton}
                >
                  {whatsAppId
                    ? i18n.t('whatsappModal.buttons.okEdit')
                    : i18n.t('whatsappModal.buttons.okAdd')}
                  {isSubmitting && (
                    <CircularProgress size={24} sx={classes.buttonProgress} />
                  )}
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </div>
  );
};

export default React.memo(WhatsAppModal);
